import React from "react";
import OperatorRequestDetails from "./OperatorRequestDetails";

const CertificateSinglenessDetails = () => <OperatorRequestDetails />;

export default CertificateSinglenessDetails;
